// src/utils/axios.ts
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

// Get base URL from environment variable or use default
//const BASE_URL = 'http://localhost:5000';
const BASE_URL = 'https://backend.sme-informatica.com'//process.env.REACT_APP_API_BASE_URL || 'https://api.qr-c.io';

// Create axios instance with default config
const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Add auth token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log request in development
    if (process.env.NODE_ENV === 'development') {
      console.log('🚀 Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        data: config.data,
      });
    }

    return config;
  },
  (error: AxiosError) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // Log response in development
    if (process.env.NODE_ENV === 'development') {
      console.log('✅ Response:', {
        status: response.status,
        data: response.data,
      });
    }

    return response;
  },
  (error: AxiosError) => {
    // Handle specific error cases
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;

      switch (status) {
        case 401:
          console.error('🔒 Unauthorized - redirecting to login');
          // Clear auth token
          localStorage.removeItem('authToken');
          // Optionally redirect to login
          // window.location.href = '/login';
          break;

        case 403:
          console.error('🚫 Forbidden - insufficient permissions');
          break;

        case 404:
          console.error('🔍 Not Found');
          break;

        case 500:
          console.error('💥 Server Error');
          break;

        default:
          console.error(`❌ Error ${status}:`, data);
      }
    } else if (error.request) {
      // Request made but no response received
      console.error('📡 Network Error - No response received');
    } else {
      // Something else happened
      console.error('❌ Error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;